export const CONTACT_LINKS = {
  email: "mailto:pdwxn@protonmail.com",
  github: "https://github.com/Pdwxn",
  linkedin: "https://www.linkedin.com/in/jesusparaguan",
};

export const RESUME_FILES = {
  es: "/files/jesus-paraguan-cv-es.pdf",
  en: "/files/jesus-paraguan-resume-en.pdf",
};
